import { StarIcon } from '@heroicons/react/24/solid'
import styles from './styles.module.scss'

interface IProps {
  name: string
  rating?: number | null
}

const ReviewRating = ({ name, rating }: IProps) => {
  if (!rating) return null

  return (
    <div className='flex items-center'>
      <div className='flex items-center mb-1 w-full'>
        <p className={styles.reviewRating__text}>{name}</p>
        <StarIcon
          className='w-8 h-8 ml-2 -mr-1 text-purple'
          style={{ flex: '0 0 auto' }}
        />
        <div className={`ml-2 text-purple ${styles.reviewRating__starText}`}>
          {rating.toFixed(1)}
        </div>
      </div>
    </div>
  )
}

export default ReviewRating
